import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
} from "recharts";
import Spinner from "./Spinner";

const AgePyramid = ({ ageBands, loading }) => {
  const pyramidData = (ageBands || []).map((b) => ({
    label: b.label,
    male: -b.male,
    female: b.female,
  }));

  return (
    <div className="bg-white rounded-2xl border border-slate-200/60 shadow-sm p-6">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="font-medium text-slate-800 text-sm">Pyramide des âges</h3>
          <p className="text-xs text-slate-400 mt-0.5">Tranches de 5 ans</p>
        </div>
        <div className="flex items-center gap-4 text-xs text-slate-500">
          <span className="flex items-center gap-1.5">
            <span className="inline-block w-3 h-3 rounded-sm" style={{ backgroundColor: "#60A5FA" }} />
            Hommes
          </span>
          <span className="flex items-center gap-1.5">
            <span className="inline-block w-3 h-3 rounded-sm" style={{ backgroundColor: "#FB7185" }} />
            Femmes
          </span>
        </div>
      </div>
      {loading ? (
        <div className="flex items-center justify-center h-64">
          <Spinner />
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={340}>
          <BarChart
            data={pyramidData}
            layout="vertical"
            stackOffset="sign"
            margin={{ left: 0, right: 8, top: 0, bottom: 0 }}
            barSize={9}
          >
            <XAxis
              type="number"
              tickFormatter={(v) => Math.abs(v)}
              tick={{ fontSize: 10, fill: "#94a3b8" }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              type="category"
              dataKey="label"
              tick={{ fontSize: 10, fill: "#64748b" }}
              axisLine={false}
              tickLine={false}
              width={42}
            />
            <Tooltip
              cursor={{ fill: "#f8fafc" }}
              contentStyle={{ border: "1px solid #e2e8f0", borderRadius: 10, fontSize: 11, padding: "6px 12px" }}
              formatter={(v, name) => [Math.abs(v), name === "male" ? "Hommes" : "Femmes"]}
            />
            <Bar dataKey="male" fill="#60A5FA" radius={[0, 4, 4, 0]} stackId="s" />
            <Bar dataKey="female" fill="#FB7185" radius={[0, 4, 4, 0]} stackId="s" />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default AgePyramid;
